import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import useStyles from './style'
import InputFormikField from '../input-formik-field/index.component'

type Props = {
  verificationCode?: boolean
  twoFactorStatus: TwoFactorStatus
}

const TwoFactorDigitsComponent = ({
  verificationCode,
  twoFactorStatus,
}: Props) => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  return (
    <>
      <Box
        display="flex"
        justifyContent={verificationCode ? 'space-between' : 'center'}
        alignItems={verificationCode ? 'center' : 'start'}
        flexDirection={verificationCode ? 'row' : 'column'}
      >
        <Typography component="p">{t('verficationCode')}:</Typography>
        <InputFormikField
          className={`${classes.twoFactorCode}`}
          sx={{
            maxWidth: verificationCode ? 300 : '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
          name="twoFactorCode"
          inputProps={{ maxLength: 6 }}
        />
      </Box>
      {twoFactorStatus === TwoFactorStatus.ERROR && (
        <Box
          mt={1}
          display="flex"
          justifyContent={verificationCode ? 'end' : 'start'}
        >
          <Typography variant="body2" paragraph className="red">
            {t('twoFactor.twoFactorWrongMessage')}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default TwoFactorDigitsComponent
